<template>
  <section class="s-marquee">
    <span class="marquee">{{ marquee }}&nbsp;{{ marquee }}</span>
  </section>
</template>

<script>
import axios from 'axios';
import { app } from '@/utils/store';

import Marquee from './marquee';

let marquee;

export default {
  data() {
    return {
      path: '/',
      lang: app.language,
      marquee: this.marquee,
    };
  },
  created() {
    axios.get(`${this.path}json/marquee.json`).then((response) => {
      if (app.language === 'it') {
        this.marquee = response.data.it.marquee;
      } else {
        this.marquee = response.data.en.marquee;
      }
    });
  },
  mounted() {
    marquee = new Marquee();
    marquee.init();
  },
  destroyed() {
    marquee.destroy();
  },
};
</script>
